import React from 'react';
import Button from './Button';
import style from './componentCss/ZigZagCard.module.css';
import ScrollUpComponent from './ScrollEventComponent';

function ZigZagCard({ imageSrc, title, paragraph, button, flip = false }) {
  return (
    <ScrollUpComponent>
      <div className={`${style.zzcontainer} ${flip ? style.flip : ''}`}>
        <div className={style.imgContainer}>
          <img
            className={style.cardImage}
            src={imageSrc}
            alt={title || "Image"}
          />
        </div>
        <div className={style.textContainer}>
          <div className={style.cardTitleBar}>
            <div className={style.blueBar}></div>
            <div className={style.cardTitle}>{title}</div>
          </div>
          <div className={style.cardParagraph}>{paragraph}</div>
          {button && (
            <div className={style.buttonContainer}>
              <Button className={style.cardButton}>
                {button}
              </Button>
            </div>
          )}
        </div>
      </div>
    </ScrollUpComponent>
  );
}

export default ZigZagCard;
